// app/webpack/javascripts/controllers/public/microphone_controller.js

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    // Attempt to request permission on load.
    // Some browsers may require a user gesture; in that case this will no-op until the button is clicked.
    this.requestMicrophone({ onConnect: true }).catch(() => {});
  }

  request() {
    // Stimulus action: click->public--microphone#request
    this.requestMicrophone().catch(() => {});
  }

  async requestMicrophone({ onConnect = false } = {}) {
    if (this._inFlight) return;
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      console.warn("[public--microphone] navigator.mediaDevices.getUserMedia is not supported in this browser.");
      return;
    }

    this._inFlight = true;
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      try {
        // Immediately stop any tracks; we only needed the permission grant.
        stream.getTracks().forEach((t) => t.stop());
      } catch (_) {}
      this.element.setAttribute("data-microphone-permission", "granted");
      console.log("[public--microphone] Microphone access granted.");
    } catch (error) {
      this.element.setAttribute("data-microphone-permission", "denied");
      console.warn("[public--microphone] Microphone access denied or error:", error && (error.name || error.message) || error);
      if (!onConnect) {
        throw error;
      }
    } finally {
      this._inFlight = false;
    }
  }
}
